/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_RisksInputs */

const en_footer_risks = /** @type {(inputs: Footer_RisksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risks`)
};

/**
* | output |
* | --- |
* | "Risks" |
*
* @param {Footer_RisksInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_risks = /** @type {((inputs?: Footer_RisksInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_RisksInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_risks(inputs)
});